import React from 'react';
import { Label, FormGroup } from 'reactstrap';
import SignaturePad from '../../SignaturePad';

const SignatureSection = ({
  firmaCliente,
  firmaRecepcionista,
  onSignatureChange,
}) => {
  return (
    <div className="row">
      <div className="col-6">
        <FormGroup>
          <Label>Firma cliente</Label>
          <SignaturePad
            width={500}
            height={200}
            lineColor="#000000"
            lineWidth={2}
            clearButtonText="Limpiar"
            onSignatureChange={(data) => onSignatureChange('firma_cliente', data)}
          />
        </FormGroup>
      </div>
      <div className="col-6">
        <FormGroup>
          <Label>Firma recepcionista</Label>
          <SignaturePad
            width={500}
            height={200}
            lineColor="#000000"
            lineWidth={2}
            clearButtonText="Limpiar"
            onSignatureChange={(data) => onSignatureChange('firma_recepcionista', data)}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default SignatureSection;
